import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';

import ListToolbar from './ListToolbar';

interface ListSectionProps {
    title?: ReactNode;
    description?: ReactNode;
    search?: ReactNode;
    controls?: ReactNode;
    filters?: ReactNode;
    footer?: ReactNode;
    children: ReactNode;
    className?: string;
    contentClassName?: string;
    headerClassName?: string;
    toolbarClassName?: string;
    footerClassName?: string;
}

export default function ListSection({
    title,
    description,
    search,
    controls,
    filters,
    footer,
    children,
    className,
    contentClassName,
    headerClassName,
    toolbarClassName,
    footerClassName,
}: ListSectionProps) {
    const hasHeader = Boolean(title || description || search || controls || filters);

    return (
        <Card
            className={cn(
                'overflow-hidden rounded-[calc(var(--radius)+0.25rem)] border border-border/80 bg-card/95 shadow-elevation-1',
                className,
            )}
        >
            {hasHeader && (
                <CardHeader className={cn('border-b border-border/70 p-6', headerClassName)}>
                    <ListToolbar
                        title={title}
                        description={description}
                        search={search}
                        controls={controls}
                        filters={filters}
                        className={toolbarClassName}
                    />
                </CardHeader>
            )}

            <CardContent className={cn('p-0', contentClassName)}>{children}</CardContent>

            {footer && (
                <div
                    className={cn(
                        'border-t border-border/70 bg-surface-muted/70 px-6 py-4',
                        footerClassName,
                    )}
                >
                    {footer}
                </div>
            )}
        </Card>
    );
}
